import './fonts/fonts.css';
import collegeBlockWoff2 from './fonts/CollegeBlock.woff2';
import collegeBlockWoff from './fonts/CollegeBlock.woff';
import jerseyM54Woff2 from './fonts/JerseyM54.woff2';
import jerseyM54Woff from './fonts/JerseyM54.woff';

// Numbers: collegiate block face. Names: Jersey M54. Fallbacks cover the
// moment before the webfont has loaded.
export const NUMBER_FONT = "'CollegeBlock', 'Anton', 'Oswald', Impact, 'Arial Black', sans-serif";
export const NAME_FONT = "'JerseyM54', Arial, sans-serif";

// Font files the PNG export has to embed (an SVG rendered through <img> cannot
// see the page's @font-face rules).
export const EXPORT_FONTS = [
    { family: 'CollegeBlock', woff2: collegeBlockWoff2, woff: collegeBlockWoff },
    { family: 'JerseyM54', woff2: jerseyM54Woff2, woff: jerseyM54Woff },
];
